import Shell from './core/shell'
import type { GoToExperienceConfig } from './experiences'
import './packages/shell-controller/shell-controller'
import './sass/index.scss'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

export default new Shell()

import './service-workers/shell-sw-registration'

/* istanbul ignore next */
export { eventEmitter } from './services/namespaces/event-bus'
export { loadCSS, loadScript } from './common/helpers'
export { createExperienceLoader } from './common/loaders'
export { getCurrentLocale } from './services/i18n'
export { GOTO_SHELL_VERSION } from './common/version'
export { Environment, getCurrentEnvironment } from './environments'
export { UserProfileEntitlement } from './services/identity/models'
export type { IToken } from '@getgo/auth-client'
export type {
  SnackbarNotification,
  BannerNotification,
  ModalNotification,
} from './services/display-notification/models'
export type { Snackbar } from './services/display-notification'
export type {
  ShellHostConfig,
  ShellApi,
  ShellUserAuthorityContextOverrideParams,
  ShellUserAuthorityContext,
  ShellConfig,
} from './core/models'
export { ShellLicenseType, ShellUserAuthorityContextPermissions } from './core/models'
export * from './core/user-info/model'
export type { NavigationLink, ShellAction } from './common/global-props'
export type { GoToExperienceConfig }
export type { UserProfileEmail } from './services/identity/models'
export type { containerAPI } from './services/container'
export type { CalendarEvent } from './services/calendar/models'
export { ConnectedServiceType as ConnectedCalendarServiceType } from './services/calendar/models'
export { updateBadge } from './services/badge'
export { LaunchDarklyVariations } from './services/feature-flags/models'
export type { LaunchDarklyPayload } from './services/feature-flags/models'
export type { NotificationChannelEvent, NotificationChannelEventData } from './services/notification-channel/models'
export type { I18NEvents } from './services/i18n'
export type { NotificationSettingsEvents } from './services/notification-settings/events'
export type { GeneralNotificationSettings } from './services/notification-settings/models'
export { NotificationChannelNamespace, NotificationChannelEvents } from './services/notification-channel/index'
export { PresenceServiceNamespace, PresenceEvents } from './services/presence'
export type { PresenceUpdated, UserPresenceUpdated } from './services/presence'
export * from './extensions'
export * from './eom'
export * from './packages/global-search'
export { GoToDatePicker, GoToDatePickerProps } from './packages/date-picker'
export { GoToFilePicker } from './packages/file-picker'
export { ShellNamespace, shellEvents, ShellReloadEvent, ShellAppChangedEventsPayload } from './services/shell-namespace'
export { getShellLogger } from './common/logger'
export { GotoError } from './packages/error-page'
export * from './services/badge-numbers'
export type { ContactAPI } from './services/contacts'
export type { ContextApi, PbxContext } from './services/context/models'
export type { IdentityApi } from './services/identity/models'
export type { AnalyticsAPI } from './services/analytics/models'
export type { MetaServiceAPI } from './services/meta/models'
export type { ShellFeatureFlagsAPIs } from './services/feature-flags'
export type { ExtensionInterface, ExtensionsAPI } from './services/extensions'
export type { Namespace, EventBus, EventEmitter, NamespaceDef } from './services/namespaces'
export * from './services/inspector-panel'
export { authenticatedFetch, ShellAuthApi } from './services/auth'
export type { AccountEvents, AccountSwitchCompletedPayload } from './services/account'
export type { AppStateService, BusyState } from './services/app-state'
export type { AppManagerAPI } from './services/app-manager'
export type { ShellBrandingApi } from './services/branding'
export { getBrowser, getOS } from './common/user-agent-helpers'
export type { ContainerAPI } from './services/container'
